import React from "react";

function CloudIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64pt"
      height="64pt"
      viewBox="0 0 64 64"
    >
      <path d="M32 24L20 36h8v20h8V36h8zm20-4c-.547 0-1.07.086-1.602.16C47.352 13.012 40.258 8 32 8s-15.348 5.012-18.398 12.16C13.07 20.086 12.547 20 12 20 5.371 20 0 25.375 0 32c0 6.629 5.371 12 12 12 1.281 0 2.492-.266 3.648-.652 2.133 2.363 5.059 3.949 8.352 4.433v-4.078c-3.117-.648-5.727-2.676-7.04-5.484C15.595 39.312 13.89 40 12 40c-4.414 0-8-3.586-8-8s3.586-8 8-8c1.578 0 3.04.473 4.273 1.258C17.586 17.734 24.102 12 32 12c7.906 0 14.36 5.766 15.656 13.297A7.955 7.955 0 0152 24c4.414 0 8 3.586 8 8s-3.586 8-8 8c-.64 0-1.25-.094-1.852-.234C48.34 42.32 45.371 44 42 44a8.9 8.9 0 01-2-.25v4.059c.652.105 1.316.191 2 .191 3.824 0 7.281-1.543 9.813-4.027.062 0 .117.027.187.027 6.629 0 12-5.371 12-12 0-6.625-5.371-12-12-12zm0 0"></path>
    </svg>
  );
}

export default CloudIcon;



// WEBPACK FOOTER //
// ./src/components/CampaignEdit/svg/CloudIcon.jsx